module.exports = __webpack_public_path__ + "static/media/intro.bc61cef0.mp3";